import { Component, HostListener, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmService } from '../../services/confirm.service';

/** Global confirmation dialog host — rendered once in app.html; driven by ConfirmService. */
@Component({
  selector: 'app-confirm-dialog',
  imports: [CommonModule],
  template: `
    @if (svc.current(); as req) {
      <div class="fixed inset-0 z-[300] flex items-center justify-center p-4" style="animation: cdFade .15s ease-out">
        <div class="absolute inset-0 bg-black/50" (click)="svc.cancel()"></div>
        <div class="relative bg-white rounded-sm shadow-2xl w-full max-w-[400px] p-6"
             style="animation: cdIn .18s ease-out" role="alertdialog" aria-modal="true">
          <h3 class="text-[16px] font-bold text-[#282c3f] mb-2">{{ req.title }}</h3>
          <p class="text-[14px] text-[#535665] mb-6">{{ req.message }}</p>
          <div class="flex justify-end gap-3">
            <button (click)="svc.cancel()"
                    class="px-5 h-[40px] border border-[#d4d5d9] rounded-sm text-[13px] font-semibold text-[#282c3f] hover:bg-gray-50 transition-colors">
              {{ req.cancelText }}
            </button>
            <button (click)="svc.accept()" autofocus
                    class="px-5 h-[40px] rounded-sm text-[13px] font-bold text-white transition-colors"
                    [style.background]="req.danger ? '#ff0000' : '#00a99d'">
              {{ req.confirmText }}
            </button>
          </div>
        </div>
      </div>
    }
  `,
  styles: [`
    @keyframes cdFade { from { opacity: 0 } to { opacity: 1 } }
    @keyframes cdIn { from { opacity: 0; transform: translateY(10px) scale(.98) } to { opacity: 1; transform: none } }
  `],
})
export class ConfirmDialog {
  readonly svc = inject(ConfirmService);
  @HostListener('document:keydown.escape') onEsc() { if (this.svc.current()) this.svc.cancel(); }
}
